import { collectionConstants } from '../constants';
import { collectionService } from '../../services';

export const collectionActions = {
  collectionsList,
  addCollection,
  getCollection,
  updateCollection
}

/*
ACTION: Collections List
*/
function collectionsList(pageID, perPage, searchInput) {
  return dispatch => {
    dispatch(request());
    return collectionService.collectionsList(pageID, perPage, searchInput)
      .then(
        response => {
          dispatch(success(response.data.body.collections, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: collectionConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: collectionConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: collectionConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Collection
*/
function addCollection(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return collectionService.addCollection(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: collectionConstants.ADD_REQUEST } }
  function success(status) { return { type: collectionConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: collectionConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Collection By ID
*/
function getCollection(addToast, collectionID) {
  return dispatch => {
    dispatch(request());
    return collectionService.getCollection(collectionID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: collectionConstants.GET_REQUEST } }
  function success(item) { return { type: collectionConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: collectionConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Collection
*/
function updateCollection(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return collectionService.updateCollection(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: collectionConstants.UPDATE_REQUEST } }
  function success(status) { return { type: collectionConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: collectionConstants.UPDATE_FAILURE, error } }
}